export const purchases = {
  title: "My Purchases",
  searchPlaceholder: "Search purchases",
  pageTitle: "My Purchases | GlobalComix",
  emptyState: "No purchases yet",
};
